<template>
  <div class="about">
    <div style="width:100%;height:26.1vw;background-size:100% 100%;display:flex;justify-content:center;align-items:center;color:#9A9A9A;">
      <img style="height:100%;width:100%;" :src="baseUrl+aboutForm.image_url" :onerror="default_thumbnail_img" />
    </div>
    <div v-if="aboutForm.name" class="school-title">{{aboutForm.name}}</div>
    <div v-if="aboutForm.introduction" class="school-detail">{{aboutForm.introduction}}</div>
    <div v-if="!aboutForm.name&&!aboutForm.introduction">暂无内容</div>
  </div>
</template>

<script>
import schoolApi from "@/api/school";
import areaApi from "@/api/area";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "About",
  data() {
    return {
      schoolId: 0,
      areaId: 0,
      isSchool: true,
      aboutForm: {},
      baseUrl: window.staticsHost,
      default_thumbnail_img: 'this.src="' + require("@/common/img/default3.png") + '"'
    }
  },
  created() {
    this.getSchoolId();
  },
  mounted() {
    if (this.isSchool) {
      this.getSchoolIntroduction();
    } else {
      this.getAreaIntroduction();
    }
  },
  methods: {
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      if (getStorage("user")) {
        let data = getStorage("user");
        if (data.area_type == 2) {
          this.schoolId = data.area_id;
          this.isSchool = true;
        } else {
          this.areaId = data.area_id;
          this.isSchool = false;
        }
      } else {
        if (getStorage("school")) {
          let data = getStorage("school");
          if (data.org_type == 2) {
            this.schoolId = data.org_id;
            this.isSchool = true;
          } else {
            this.areaId = data.org_id;
            this.isSchool = false;
          }
        }
      }
    },
    // 获取校园简介详情
    getSchoolIntroduction() {
      schoolApi.getSchoolIntroduction(this.schoolId).then((response) => {
        if (response.data.status == 0) {
          this.aboutForm = response.data.data;
        } else {
          console.log(response.data.info.detail);
          this.$message({
            type: "warning",
            message: response.data.info.message,
          });
        }
      });
    },
    // 获取区域简介详情
    getAreaIntroduction() {
      areaApi.getAreaIntroduction(this.areaId).then((response) => {
        if (response.data.status == 0) {
          this.aboutForm = response.data.data;
        } else {
          console.log(response.data.info.detail);
          this.$message({
            type: "warning",
            message: response.data.info.message,
          });
        }
      });
    }
  }
}
</script>

<style scoped lang="stylus">
.about {
  width: 100%;
  min-height: calc(100vh - 144px);

  .school-title {
    font-weight: bold;
    font-size: 18px;
    margin-top: 40px;
  }

  .school-detail {
    text-align: justify;
    line-height: 2rem;
    padding: 15px 50px 40px 50px;
    box-sizing: border-box;
  }
}
</style>